/**
 * NFL offensive fantasy scoring — Full PPR (TE-premium).
 *
 * Single source of truth for the offensive point values used by the NFL Playoff
 * and NFL No-Repeat pools (see NFL_No_Repeat_Challenge_Pool_Rules.md §6):
 *   - Passing: 1 pt / 20 yds, TD 4, INT −1
 *   - Rushing/Receiving: 1 pt / 10 yds, TD 6
 *   - Reception: 1.0 (QB/RB/WR), 1.5 (TE — TE-premium PPR)
 *   - 2-pt conversion: 2, Fumble lost: −1
 * No double-point multiplier is applied here; that is a per-event concern.
 */
export interface OffensiveStatLine {
  passingYards?: number;
  passingTDs?: number;
  interceptions?: number;
  rushingYards?: number;
  receivingYards?: number;
  rushingTDs?: number;
  receivingTDs?: number;
  receptions?: number;
  twoPointConversions?: number;
  fumblesLost?: number;
}

/** Compute Full-PPR offensive fantasy points for a stat line, rounded to 0.1. */
export function calculateOffensiveFantasyPoints(
  stats: OffensiveStatLine,
  position: string,
): number {
  let total = 0;
  total += (stats.passingYards || 0) / 20;
  total += (stats.passingTDs || 0) * 4;
  total -= stats.interceptions || 0;
  total += (stats.rushingYards || 0) * 0.1;
  total += (stats.receivingYards || 0) * 0.1;
  total += (stats.rushingTDs || 0) * 6;
  total += (stats.receivingTDs || 0) * 6;
  const receptionPoints = position === 'TE' ? 1.5 : 1;
  total += (stats.receptions || 0) * receptionPoints;
  total += (stats.twoPointConversions || 0) * 2;
  total -= stats.fumblesLost || 0;
  return Math.round(total * 10) / 10;
}
